// extracted by mini-css-extract-plugin
export default {"heading":"yt-z","corrected":"zt-z","redirectVerbiageContainer":"At-z","redirectVerbiageText":"Bt-z"};